import {
  CancelOrderParams,
  CreateOrder,
  Order,
  OrderList,
  OrderListSchema,
  OrderSchema,
  ReshopOrder,
  ReshopOrderSchema,
} from '@reward-platform/order-schemas/order'
import qs from 'qs'
import { nextApiClient } from './clients/nextApiClient'
import { createServiceSchemaValidator } from './utils'

const validateOrder = createServiceSchemaValidator(OrderSchema)
const validateOrderList = createServiceSchemaValidator(OrderListSchema)
const validateReshopOrder = createServiceSchemaValidator(ReshopOrderSchema)

export async function getCaptureContext(): Promise<{
  clientLibrary: string
  clientLibraryIntegrity: string
  captureContext: string
}> {
  const { data } = await nextApiClient.get(`/orders/payment/capture-context`)
  return data
}

// Creating and paying for an order can take close to 2 minutes, longer than the 60s
// nextApiClient default
export const ORDER_BOOKING_TIMEOUT_MS = 125000

// TODO: return type should be Promise<OrderResponse>
export async function createOrder(order: CreateOrder): Promise<Order> {
  const { data } = await nextApiClient.post(`/orders`, order, { timeout: ORDER_BOOKING_TIMEOUT_MS })
  return validateOrder(data)
}

export async function getOrder(orderId: string, resolveLocations = false): Promise<Order> {
  const urlSearchParams = new URLSearchParams()

  if (resolveLocations) {
    urlSearchParams.append('resolveLocations', resolveLocations.toString())
  }

  const query = urlSearchParams.toString()
  const queryString = query.length ? `?${query}` : ''

  const { data } = await nextApiClient.get<Order>(`/orders/${orderId}${queryString}`)
  return validateOrder(data)
}

export async function getOrderList(pageNumber: number, pageSize: number): Promise<OrderList> {
  const queryString = qs.stringify({ pageNumber, pageSize })
  const { data } = await nextApiClient.get<Order>(`/orders?${queryString}`)

  return validateOrderList(data)
}

export const updateOrder = async (
  orderId: string,
  paymentId: string,
  is3DS: boolean
): Promise<void> => {
  await nextApiClient.put(
    `/orders/${orderId}`,
    { paymentId, is3DS },
    { timeout: ORDER_BOOKING_TIMEOUT_MS }
  )
}

export async function reShopOrder(orderId: string, bundleRefs: string[]): Promise<ReshopOrder> {
  const { data } = await nextApiClient.post<Order>(`/orders/${orderId}/reshop`, {
    bundleRefs,
  })
  return validateReshopOrder(data)
}

export async function cancelOrder(orderId: string, recommendationId: string, bundleId: string) {
  const params: CancelOrderParams = {
    bundleId,
    orderId,
    recommendationId,
  }
  await nextApiClient.post(`/orders/${orderId}/cancel`, params)
}

export async function verifyMerchant(
  validationURL: string,
  hostname: string
): Promise<{
  merchantSession: string
}> {
  const { data } = await nextApiClient.post(`/apple-pay/merchant-validation`, {
    validationURL,
    hostname,
  })

  return data
}
